<template>
  <div v-if="label">
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">{{showBenchmarking ? label.titles.titleAlt : label.titles.title}}  <Info multilined bottom :tooltipText="showBenchmarking ? label.titles.titleAltTooltip : label.titles.titleTooltip"/></h1>
        </div>
      </div>
    </section>

    <div class="container">
      <div class="tile is-ancestor is-vertical">
        <!-- Graphe et filtres -->
          <div class="tile">
            <div class="tile is-parent is-8">
              <div class="tile is-child box graph-box">

                <section class="graph-top">

                  <!-- History Stack -->
                  <!-- <div class="graph-top-history">
                    <div class="buttons has-addons">
                      <button
                        class="button has-tooltip-top has-tooltip-multiline"
                        @click="changeHistory(-1)"
                        :disabled="historyPosition == 0 || loadingData"
                        :data-tooltip="label.buttons.previousTooltip"
                      >
                        {{label.buttons.previous}}
                      </button>
                      <button
                        class="button has-tooltip-top has-tooltip-multiline"
                        @click="changeHistory(+1)"
                        :disabled="historyPosition == historyStack.length-1 || loadingData"
                        :data-tooltip="label.buttons.nextTooltip"
                      >
                        {{label.buttons.next}}
                      </button>
                    </div>
                  </div> -->

                  <div class="graph-top-history">
                    <div class="buttons has-addons">
                      <button
                        class="button has-tooltip-top has-tooltip-multiline"
                        @click="goUpAggregation"
                        :disabled="aggregation === 'YEAR' || loadingData"
                        data-tooltip="Niveau supérieur"
                      >
                    <span>{{label.buttons.previous}}</span>
                    </button>
                    </div>
                  </div>

                  <!-- Date Shifters (Next/Prev Period)
                  <div v-if="!compareByYear && !isComparePage && ['QUARTER_H', 'HOUR'].includes(aggregation)" class="graph-top-shifter">
                    <div class="buttons has-addons">
                      <button
                        class="button has-tooltip-top has-tooltip-multiline"
                        @click="shiftDatePeriod(-1)"
                        :disabled="loadingData"
                        data-tooltip="Période précédente"
                      >
                        <span class="icon is-small"><awesome-icon icon="chevron-left" aria-hidden="true"/></span>
                      </button>
                      <button
                        class="button has-tooltip-top has-tooltip-multiline"
                        @click="shiftDatePeriod(1)"
                        :disabled="loadingData"
                        data-tooltip="Période suivante"
                      >
                        <span class="icon is-small"><awesome-icon icon="chevron-right" aria-hidden="true"/></span>
                      </button>
                    </div>
                  </div> -->

                  <div class="graph-top-context" style="flex-grow: 1; display: flex; justify-content: center;">
                    <span v-if="currentDateContext" class="tag is-info is-light is-medium" style="font-weight: 600; font-size: 1rem;">
                      {{ currentDateContext }}
                    </span>
                  </div>

                  <!-- Add index / event -->
                  <div v-if="!isComparePage" class="graph-top-actions">
                    <div class="buttons has-addons" v-if="clipod">
                       <!-- Add index -->
                      <!-- <button
                        v-if="maxDate < today && allowedToAddIndex"
                        class="button is-primary is-outlined"
                        @click="showModalIndex = true, loadingData = true, loadingMessage=label.texts.loadingIndexes">{{label.buttons.addIndex}}</button>
                      <button
                        v-else
                        class="button is-primary is-outlined has-tooltip-top"
                        disabled
                        :data-tooltip= "allowedToAddIndex ? label.texts.indexAlreadyToday : label.texts.noAccessIndex">
                        {{label.buttons.addIndex}}
                      </button> -->

                      <!-- Add event -->
                      <button
                        v-if="!clipod.pod.location || !allowedToAddEvent"
                        class="button is-primary is-outlined has-tooltip-top"
                        disabled
                        :data-tooltip="allowedToAddEvent ? 'Votre point d\'accès doit avoir une adresse liée pour enregistrer un évènement' : label.texts.noAccessEvent">
                        {{label.buttons.addEvent}}
                      </button>
                      <button
                        v-else
                        class="button is-primary is-outlined"
                        :disabled="!allowedToAddEvent"
                        @click="showModalEvent = true, loadingData = true">{{label.buttons.addEvent}}</button>
                    </div>
                  </div>
                </section>

                <section class="graph">

                  <!-- Loading -->
                  <div v-if="loadingData || tooManyData" style="height: 300px;">
                    <p v-if="tooManyData" class="notification is-warning">{{label.texts.periodTooBig}}</p>
                    <div class="loading" v-if="loadingData">{{loadingMessage ? loadingMessage : label.texts.loading}}</div>
                  </div>

                  <!-- Graphe -->
                  <div v-else>
                    <Chart v-if="registersData && registersData.length > 0" :registersData="registersData"
                      :selectedTimeframes="selectedTimeframes" @clickedBar="onBarClicked"
                      :allDates="allDates"
                      :aggregation="aggregation" :compareByYear="compareByYear" :yearsToCompare="yearsToCompare"
                      :fromMonth="fromMonth" :fromDay="fromDay" :toMonth="toMonth" :toDay="toDay"
                      :overallConsumptions="overallConsumptions" :allRegistersIDs="allRegistersIDs"
                      :podInputUnit="viewMultiplePods ? 'kWh' : clipod.pod.energy.inputUnit"
                      :conversionToKWH="viewMultiplePods ? 1 : clipod.personalizedEnergyConversion ? clipod.personalizedEnergyConversion: clipod.pod.energy.conversionToKWH"
                      :dataIsInKWH="showingDataInKWH"
                      :groupedIncompletePeriods="groupedIncompletePeriods"
                      :currentUnit="currentUnit"
                      :viewMultiplePods="viewMultiplePods"
                      :comparePods="!stackPods"
                      :eventsWithIndex="eventsWithIndex"
                      :showBenchmarking="showBenchmarking"
                      :benchmarkingCurve="benchmarkingCurve"
                      :accessibilityEnabled="user.accessibilityEnabled"
                    />
                    
                    <div v-if="registersData && registersData.length > 0" class="has-text-centered" style="margin-top: 1.5rem;">
                      <span :class="{'has-tooltip-top has-tooltip-multiline': !isMonthViewContext}"
                            :data-tooltip="!isMonthViewContext ? 'Vous devez être sur la vue d\'un mois complet (vue par jour) pour activer la vue par semaine' : null"
                            style="display: inline-block;">
                        <label class="checkbox" :style="{ opacity: !isMonthViewContext ? 0.5 : 1, cursor: !isMonthViewContext ? 'not-allowed' : 'pointer' }">
                          <input type="checkbox"
                                 v-model="isWeekView"
                                 :disabled="!isMonthViewContext"
                                 style="margin-right: 0.5rem;">
                          <strong>Affichage par semaine</strong>
                        </label>
                      </span>
                    </div>
                    <div v-else style="height: 300px;">
                      <p class="notification is-info">{{label.texts.noData}}</p>
                    </div>
                    <p v-if="hasIncompletePeriods" id="incomplete-period-legend">(*) {{label.forms.incomplete}}   <Info multilined :tooltipText="label.forms.incompleteTooltip"/></p>
                  </div>

                </section>

                <!-- <section v-show="!compareByYear && !['QUARTER_H', 'HOUR'].includes(aggregation)" class="graph-slider">
                  <div id="slider" ref="slider"></div>
                </section> -->

                <!-- <section class="graph-bottom"> -->

                  <!-- aggregation -->
                  <!-- <div>
                    <label class="label">{{label.titles.aggregate}} <Info multilined :tooltipText="label.texts.aggregateTooltip"/></label>
                    <div class="control">
                      <div class="dropdown is-up" :class="{'is-active': aggregationActive}">
                        <div class="dropdown-trigger">
                          <button class="button" @click="aggregationActive = !aggregationActive" @blur="aggregationActive = false">
                            <span>{{aggregationText}}</span>
                            <span class="icon is-small"><awesome-icon icon="angle-up" aria-hidden="true"/></span>
                          </button>
                        </div>
                        <div class="dropdown-menu " role="menu">
                          <div class="dropdown-content">
                            <a class="dropdown-item" @mousedown="changeAggregation('YEAR')">{{label.forms.year}}</a>
                            <a class="dropdown-item" @mousedown="changeAggregation('MONTH')">{{label.forms.month}}</a>
                            <a class="dropdown-item" @mousedown="changeAggregation('WEEK')">{{label.forms.week}}</a>
                            <a class="dropdown-item" @mousedown="changeAggregation('DAY')">{{label.forms.day}}</a>
                            <template v-if="clipod && showHighFrequencyAggregations && !isComparePage"> -->
                            <!-- <a class="dropdown-item" @mousedown="changeAggregation('HOUR')">{{label.forms.hour}}</a> -->
                            <!-- <a class="dropdown-item" v-if="clipod.pod.energy.energyName === 'elec'" @mousedown="changeAggregation('QUARTER_H')">{{label.forms.quarter}}</a>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <!-- <div class="graph-bottom-date"> -->
                    <!-- select fromdate -->
                    <!-- <div>
                      <label class="label">{{label.forms.startDate}} <Info multilined :tooltipText="label.forms.startDateTooltip"/></label>
                      <div class="control">
                        <VueDatePicker
                          @input="onDateChange(true)"
                          input-class="input"
                          auto :format="formatDateByAggregation('string')"
                          :minDate="minDate"
                          :maxDate="maxDate"
                          timezone="Europe/Brussels"
                          locale="fr"
                          v-model="startDateAsIsoString"
                          :selectText="label.forms.ok"
                          :cancelText="label.forms.cancel"
                          :enableTimePicker="false"
                          weekStart='1'
                          :hideInputIcon="true"
                          disabled
                          >
                        </VueDatePicker>
                      </div>
                    </div> -->

                    <!-- select endate -->
                    <!-- <div>
                      <label class="label">{{label.forms.endDate}} <Info multilined :tooltipText="label.forms.endDateTooltip"/></label>
                      <div class="control">
                        <VueDatePicker
                          @input="onDateChange(true)"
                          input-class="input"
                          auto :format="formatDateByAggregation('string')"
                          :minDate="minDate"
                          :maxDate="maxDate"
                          timezone="Europe/Brussels"
                          locale="fr"
                          v-model="endDateAsIsoString"
                          :selectText="label.forms.ok"
                          :cancelText="label.forms.cancel"
                          :enableTimePicker="false"
                          weekStart='1'
                          :hideInputIcon="true"
                          disabled>
                        </VueDatePicker>
                      </div>
                    </div>
                  </div> -->
                <!-- </section> -->
              </div>
            </div>
            <div class="tile is-parent">
              <div class="tile is-child box filters">
                <h1 class="subtitle">{{label.forms.filters}}</h1>

                <!-- Selection POD -->
                <PodSelection :userId="user._id" :showMultiplePodSelection="viewMultiplePods" @allClipods="onClipodsLoaded" @selectedPod="onPodSelected" @allRegistersIDs="loadedAllRegisters" @multiplePodSelectionChanged="onMPRegistersChange" :fullwidth="true" ref="podSelection"/>

                <!-- Timeframe -->
                <div v-if="clipod" class="field">
                  <label class="label">{{label.forms.timeframe}} <Info multilined :tooltipText="label.forms.timeframeTooltip"/></label>
                  <div class="control" @mouseleave="timeframeActive = false">
                    <div class="dropdown full-width" :class="{'is-active': timeframeActive}">
                      <div class="dropdown-trigger full-width">
                        <button
                          class="button full-width"
                          @click="timeframeActive = !timeframeActive">
                          <span>{{timeframeText}}</span>
                          <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
                        </button>
                      </div>
                      <div class="dropdown-menu" role="menu">
                        <div class="dropdown-content">
                          <!-- "Mono-horaire" (TH, EX) -->
                          <template v-if="monoTimeframes.length > 0">
                            <div class="dropdown-item" v-for="timeframe of monoTimeframes" :key="timeframe">
                              <input
                                v-model="selectedTimeframes"
                                @change="onTimeframeCheckboxChange(timeframe)"
                                :value="timeframe"
                                :id="timeframe"
                                type="checkbox">
                              <label :for="timeframe">{{label.forms[timeframe] || 'Mono-horaire'}}</label>
                            </div>
                          </template>
                          
                          <!-- "Bi-horaire" grouping -->
                          <template v-if="biTimeframes.length > 0">
                            <div class="dropdown-item">
                              <input
                                v-model="allBiTimeframesSelected"
                                id="tarif-bi-horaire"
                                type="checkbox">
                              <label for="tarif-bi-horaire">{{label.forms.biHoraire || 'Bi-horaire'}}</label>
                            </div>
                            <template v-if="aggregation !== 'QUARTER_H'">
                              <div class="dropdown-item" style="padding-left: 2rem;" v-for="timeframe of biTimeframes" :key="timeframe">
                                <input
                                  v-model="selectedTimeframes"
                                  @change="onTimeframeCheckboxChange(timeframe)"
                                  :value="timeframe"
                                  :id="timeframe"
                                  type="checkbox">
                                <label :for="timeframe">{{label.forms[timeframe]}}</label>
                              </div>
                            </template>
                          </template>

                          <!-- "Tarif Impact" grouping, only if there's any impact timeframe available -->
                          <template v-if="impactTimeframes.length > 0">
                            <div class="dropdown-item">
                              <input
                                v-model="allImpactTimeframesSelected"
                                id="tarif-impact"
                                type="checkbox">
                              <label for="tarif-impact">{{label.forms.tarifImpact || 'Tarif Impact'}}</label>
                            </div>
                            <!-- Des sous-options décalées -->
                            <template v-if="aggregation !== 'QUARTER_H'">
                              <div class="dropdown-item" style="padding-left: 2rem;" v-for="timeframe of impactTimeframes" :key="timeframe">
                                <input
                                  v-model="selectedTimeframes"
                                  @change="onTimeframeCheckboxChange(timeframe)"
                                  :value="timeframe"
                                  :id="timeframe"
                                  type="checkbox">
                                <label :for="timeframe">{{label.forms[timeframe]}}</label>
                              </div>
                            </template>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Direction -->
                <div v-if="clipod" class="field">
                  <label class="label">{{label.forms.direction}}  <Info multilined :tooltipText="label.forms.directionTooltip"/></label>
                  <div class="control" @mouseleave="directionActive = false">
                    <div class="dropdown full-width" :class="{'is-active': directionActive}">
                      <div class="dropdown-trigger full-width">
                        <button
                          class="button full-width"
                          @click="directionActive = !directionActive">
                          <span>{{directionText}}</span>
                          <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
                        </button>
                      </div>
                      <div class="dropdown-menu" role="menu">
                        <div class="dropdown-content">
                          <div class="dropdown-item" v-for="direction of availableDirections" :key="direction">
                            <input
                              v-model="selectedDirections"
                              @change="onSelectedDirectionsChange"
                              :value="direction"
                              :id="direction"
                              type="checkbox">
                            <label :for="direction">{{direction == "prelevement" ? "Prélèvement" : "Injection"}}</label>
                             <!-- <label :for="sce">{{getSCEFriendlyName(sce)}}</label> -->
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Registres -->
                <!-- Défaut -->
                <!-- <div v-if="clipod && !viewMultiplePods" class="field">
                  <label class="label">{{label.forms.registers}} <Info multilined tooltipText="Le registre représente la partie qui enregistre votre consommation en fonction du timeframe."/></label>
                  <div class="control" @mouseleave="registerActive = false">
                    <div class="dropdown" :class="{'is-active': registerActive}">
                      <div class="dropdown-trigger">
                        <button
                          class="button"
                          @click="registerActive = !registerActive">
                          <span>{{registerText}}</span>
                          <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
                        </button>
                      </div>
                      <div class="dropdown-menu" role="menu">
                        <div class="dropdown-content">
                          <div class="dropdown-item" v-for="variable of availableRegisters" :key="variable.id">
                            <input
                              v-model="selectedRegisters"
                              @change="onSelectedRegistersChange"
                              :value="variable.id"
                              :id="variable.id"
                              type="checkbox">
                            <label :for="variable.id">{{variable.name}}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- MultiplePods -->
                <!-- <div v-if="clipod && viewMultiplePods" class="field">
                  <label class="label">{{label.forms.registers}}</label>
                  <div class="control" @mouseleave="registerActive = false">
                    <div class="dropdown" :class="{'is-active': registerActive}">
                      <div class="dropdown-trigger">
                        <button
                          class="button"
                          @click="registerActive = !registerActive">
                          <span>Sélection</span>
                          <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
                        </button>
                      </div>
                      <div class="dropdown-menu" role="menu">
                        <div class="dropdown-content">
                          <div v-for="(clipod, index) of allClipods" v-bind:key="clipod.pod.id">
                            <div class="dropdown-item">
                              <div class="item-pod">
                                <input
                                  v-model="multiplePodSelection[clipod.pod.id].selected"
                                  @change="onMPPodChange('selectMultiplePOD')"
                                  :value="clipod.pod"
                                  :id="clipod.pod.id"
                                  type="checkbox">
                                <label :for="clipod.pod.id">
                                  {{clipod.podCustomName}}
                                </label>
                              </div>
                              <div class="item-register" v-if="isPodSelected(clipod.pod)">
                                <div v-for="variable of getPodAvailableRegisters(clipod.pod)" :key="variable.id">
                                  <input
                                    v-model="multiplePodSelection[clipod.pod.id].registersIDs"
                                    @change="onMPRegistersChange"
                                    :value="variable.id"
                                    :id="variable.id"
                                    type="checkbox">
                                  <label :for="variable.id">{{variable.name}}</label>
                                </div>
                              </div>
                            </div>
                            <hr class="dropdown-divider" v-if="index != allClipods.length-1">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

                <!-- Switch comparaison -->
                <div v-if="isComparePage" class="field" style="margin-bottom: 0px">
                  <label class="label">{{label.forms.display}}  <Info multilined :tooltipText="label.forms.displayTooltip"/></label>
                  <div class="buttons has-addons group-full-width" style="margin-bottom: 0;">
                    <button
                      type="button"
                      class="button group-full-width has-tooltip-top has-tooltip-multiline"
                      :class="{'is-primary': showBenchmarking, 'is-selected': showBenchmarking}"
                      @click="onBenchmarkingClick"
                      :data-tooltip="label.forms.benchmarkingTooltip">{{label.forms.benchmarking}}</button>
                    <button
                      type="button"
                      class="button group-full-width has-tooltip-top has-tooltip-multiline"
                      :class="{'is-primary': compareByYear, 'is-selected': compareByYear}"
                      @click="onCompareClick"
                      :data-tooltip="label.forms.historyTooltip">{{label.forms.history}}</button>
                    <button
                      type="button"
                      class="button group-full-width has-tooltip-top has-tooltip-multiline"
                      :class="{'is-primary': viewMultiplePods, 'is-selected': viewMultiplePods}"
                      @click="onViewMultiplePodsSelected"
                      :data-tooltip="label.forms.accessPointTooltip">{{label.forms.accessPoint}}</button>
                  </div>
                </div>

                <div class="field" v-show="(clipod && clipod.pod.energy.conversionToKWH !== 1) || (isComparePage && viewMultiplePods)">
                  <label v-if="!isComparePage" class="label">{{label.forms.display}}  <Info multilined :tooltipText="label.forms.displayTooltipAlt"/></label>
                  <!-- Sélection d'énergie -->
                  <div v-if="clipod && clipod.pod.energy.conversionToKWH != 1">
                    <input :disabled="convertingData || isComparePage" :checked="showingDataInKWH" @click="convertData" id="showDataInKWH" type="checkbox">
                    <label for="showDataInKWH">{{label.buttons.kwh}}</label>
                  </div>

                  <!-- Stack des données multiplePods -->
                  <div v-if="isComparePage && viewMultiplePods">
                    <input v-model="stackPods" id="stackPods" type="checkbox">
                    <label for="stackPods">{{label.buttons.stackPods}} <Info multilined :tooltipText="label.buttons.stackPodsTooltip"/></label>
                  </div>

                  <!-- Données météo -->
                  <!-- <div v-if="clipod">
                    <input :value="showMeteo" id="showMeteo" type="checkbox">
                    <label for="showMeteo">Afficher les données météo</label>
                  </div> -->

                  <!-- <div v-if="clipod">
                    <input type="checkbox">
                    <label>Afficher les données en euros</label>
                  </div> -->

                  </div>
                  
                  <!-- Refresh and print -->
                  <div class="field">
                  <label class="label">{{label.forms.actions}}</label>
                  <div class="buttons has-addons group-full-width">
                    <!-- Refresh -->
                    <button
                      class="button group-full-width is-outlined has-tooltip-top has-tooltip-multiline"
                      @click="loadTimeSeries('refresh')"
                      :data-tooltip="label.buttons.refreshTooltip">
                        {{label.buttons.refresh}}
                    </button>

                    <!-- Print -->
                    <ExportToCsv
                      v-if="registersData && registersData.length > 0 && printData && !(compareByYear || viewMultiplePods)"
                      :data="printData"
                      :fields="printFields"
                      :data-tooltip="label.buttons.downloadTooltip"
                      class="button is-outlined group-full-width has-tooltip-top has-tooltip-multiline"
                      name="download_client_portal.csv"
                    >
                      {{label.buttons.download}}
                    </ExportToCsv>

                    <button v-else
                      disabled
                      class="button group-full-width is-outlined has-tooltip-top has-tooltip-multiline"
                      :data-tooltip="(!registersData || registersData.length === 0) ? 'Veuillez sélectionner des données à visualiser sur le graphique pour activer le bouton.' : label.buttons.downloadTooltip">
                        {{label.buttons.download}}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- Infos, conseils et KPI -->
          <div class="tile">
            <div class="tile is-parent is-4 tile-min-content">
              <div class="tile is-child box">
                <Tutorial />
              </div>
            </div>
            <div class="tile is-parent is-4 tile-min-content">
              <div class="tile is-child box">
                <Tips :tips-type="this.$route.path" />
              </div>
            </div>
            <!-- <div v-if="clipod" class="tile is-parent is-4 tile-min-content">
              <div class="tile is-child box box-styled">
                <KPIHolder :clipod="clipod" :user="user"/>
              </div>
            </div> -->
            </div>
      </div>
    </div>

    <!-- Add Index modal -->
    <!-- <IndexModal
      v-if="clipod"
      :openModal="showModalIndex"
      :showCreationForm="true"
      :pod="clipod.pod"
      :minMeteringDate="minDate"
      :reloadData="addIndex"
      :closeModal="closeModal"
    /> -->

    <!-- Add Event modal -->
    <EventModal
      v-if="clipod && clipod.pod.location"
      :openModal="showModalEvent"
      :showCreationForm="true"
      :locationID="clipod.pod.location.id"
      :reloadData="loadTimeSeries"
      :closeModal="closeModal"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TimeSeriesService, PODService } from '../services';
// import VueDatePicker from '@vuepic/vue-datepicker';
// import '@vuepic/vue-datepicker/dist/main.css';
import { Settings } from 'luxon';
import moment from 'moment-timezone';
// import 'moment-range'
//import noUiSlider from 'nouislider';
//import 'nouislider/distribute/nouislider.css';

import PodSelection from '../components/PodSelection.vue'
import Chart from '../components/Chart.vue'
// import IndexModal from '../components/IndexModal.vue';
import EventModal from '../components/EventModal';
import Tutorial from "../components/Tutorial.vue"
import Tips from "../components/Tips.vue"
// import KPIHolder from '../components/KPIHolder.vue';
import Info from '../components/Info.vue'
import ExportToCsv from '../components/ExportToCsv.vue'
// import { KNOWN_TIMEFRAMES } from '../helpers/known-timeframes'
import { KNOWN_DIRECTIONS } from '../helpers/known-directions'
import { DB_COLLECTIONS, getDelegationRight, whatCanDelegatedUserDo, sortRegisters } from '../helpers'
import { getSCEFriendlyName } from '../helpers/constants'
import { DIRECTION_MAPPING } from '../helpers/constants'

export default {
    components: {
      Chart,
      PodSelection,
      // IndexModal,
      EventModal,
      Tutorial,
      Tips,
      // VueDatePicker,
      ExportToCsv,
      Info,
      // KPIHolder
    },
    data() {
        return {
            isComparePage: null,
            aggregationsInOrder: ['QUARTER_H', 'HOUR', 'DAY', 'WEEK', 'MONTH', 'YEAR'],
            // nbPeriodsByAggregation: [],
            allTimeframes: [],
            allDirections: KNOWN_DIRECTIONS,
            clipod: null,
            // this array is not filled if "viewMultiplePods" is true
            selectedRegisters: [],
            availableRegisters: [],
            selectedSCE: [],
            endDate: new Date(),
            startDate: new Date(),
            // nbPeriods: null,
            compareByYear: false,
            aggregation: "MONTH",
            // consumptions : null,
            // errorMessage: null,
            loadingData: true,
            minStartDate: null,
            maxEndDate: null,
            tooManyData: false,

            viewMultiplePods: false,
            stackPods: true,
            multiplePodSelection: {},
            allClipods: [],
            availableRegistersPerPod: [],

            selectedTimeframes: [],
            selectedDirections: KNOWN_DIRECTIONS,

            // boolean, either show data in kwh or in inputUnit
            showingDataInKWH: false,
            convertingData: false,

            // if compare by year
            fromDay: null,
            fromMonth: null,
            toDay: null,
            toMonth: null,
            yearsToCompare: null,

            // benchmarking
            showBenchmarking: false,
            benchmarkingCurve: null,

            // loaded timeseries infos
            hasHighFrequencyDataCurrently: false,
            registersData: null,
            overallConsumptions: null,
            allDates: null,
            // "groupedIncompletePeriods" will contain an array of objects of of this format :
            // {
            //   podID: podID (only if "viewMultiplePods is true")
            //   registerID: register id
            //   incompletePI: array of incomplete periods
            // }
            groupedIncompletePeriods: null,

            aggregationActive: false,
            timeframeActive: false,
            directionActive: false,
            registerActive: false,
            showMeteo: false,
            printData: [],
            printFields: [],

            eventsWithIndex: [],

            firstDataDate: null,
            lastDataDate: null,
            // slider: null,
            // historyStack: [],
            historyPosition: 0,

            showModalIndex: false,
            showModalEvent: false,
            loadingMessage: '',

            // true right after switching from 15' to daily view; triggers a mono-timeframe fallback if no daily data is found
            pendingDailyFallbackCheck: false
        }
    },
    computed: {
        ...mapState("account", ["user"]),
        ...mapState({ account: state => state.account }),
        ...mapState({ label: state => state.labels.data }),
        ...mapState({ locale: state => state.labels.locale }),
        availableSCE() {
          if(!this.availableRegisters)
            return []
          return this.availableRegisters
            .filter(reg => reg.serviceComponentElement)
            .map(reg => reg.serviceComponentElement)
            .filter((sce, index, array) => {
              return array.indexOf(sce) == index
            })
        },
        availableDirections() {
          if(!this.clipod || !this.clipod.pod || !this.clipod.pod.variable)
            return ["prelevement"]
          return this.clipod.pod.variable
            .filter(reg => reg.meter && !reg.serviceComponentElement)
            .map(reg => reg.direction)
            .filter((direction, index, array) => {
              return array.indexOf(direction) == index
            })
        },
        availableTimeframes() {
          if(!this.clipod || !this.clipod.pod || !this.clipod.pod.variable)
            return ["TH"]
          return this.clipod.pod.variable
            .filter(reg => reg.meter && !reg.serviceComponentElement && reg.timeframe)
            .map(reg => reg.timeframe)
            .filter((tf, index, array) => {
              return array.indexOf(tf) == index
            })
            .filter(tf => tf !== 'PWR' && tf !== 'PWR_EX')
        },
        impactTimeframes() {
          return this.availableTimeframes.filter(tf => ["EC", "MD", "PK"].includes(tf))
        },
        biTimeframes() {
          return this.availableTimeframes.filter(tf => ["HI", "LO"].includes(tf))
        },
        monoTimeframes() {
          return this.availableTimeframes.filter(tf => !["EC", "MD", "PK", "HI", "LO"].includes(tf))
        },
        allImpactTimeframesSelected: {
          get() {
            if (this.impactTimeframes.length === 0) return false
            return this.impactTimeframes.every(tf => this.selectedTimeframes.includes(tf))
          },
          set(val) {
            if (val) {
              // Add all impact timeframes that are not currently selected
              const newTimeframes = this.selectedTimeframes.concat(
                 this.impactTimeframes.filter(tf => !this.selectedTimeframes.includes(tf))
              )
              // En vue 15', une seule "plage horaire" (famille) est sélectionnable à la fois
              this.selectedTimeframes = this.aggregation === 'QUARTER_H' ? this.impactTimeframes.slice() : newTimeframes
            } else {
              if (val) {
                const newTimeframes = this.selectedTimeframes.concat(
                  this.impactTimeframes.filter(tf => !this.selectedTimeframes.includes(tf))
                )
                this.selectedTimeframes = newTimeframes
              } else {
                this.selectedTimeframes = this.selectedTimeframes.filter(tf => !this.impactTimeframes.includes(tf))
              }
            }
            this.onSelectedTimeframesChange()
          }
        },

        allBiTimeframesSelected: {
          get() {
            if (this.biTimeframes.length === 0) return false
            return this.biTimeframes.every(tf => this.selectedTimeframes.includes(tf))
          },
          set(val) {
            if (val) {
              // Add all bi timeframes that are not currently selected
              const newTimeframes = this.selectedTimeframes.concat(
                 this.biTimeframes.filter(tf => !this.selectedTimeframes.includes(tf))
              )
              // En vue 15', une seule "plage horaire" (famille) est sélectionnable à la fois
              this.selectedTimeframes = this.aggregation === 'QUARTER_H' ? this.biTimeframes.slice() : newTimeframes
            } else {
              if (val) {
                const newTimeframes = this.selectedTimeframes.concat(
                  this.biTimeframes.filter(tf => !this.selectedTimeframes.includes(tf))
                )
                this.selectedTimeframes = newTimeframes
              } else {
                this.selectedTimeframes = this.selectedTimeframes.filter(tf => !this.biTimeframes.includes(tf))
              }
            }
            this.onSelectedTimeframesChange()
          }
        },
        startDateAsIsoString() {
          if(!this.startDate)
            return null
          return new Date(this.startDate).toISOString()
        },
        endDateAsIsoString() {
          if(!this.endDate)
            return null
          return new Date(this.endDate).toISOString()
        },
        nowAsISOString() {
          return new Date().toISOString()
        },
        delegationRight() {
          if(!this.clipod || !this.clipod.isDelegatedAccess)
            return null
          return getDelegationRight(this.clipod)
        },
        allowedToAddIndex() {
          if(!this.clipod)
            return false
          if(!this.clipod.isDelegatedAccess)
            return true
          if(!this.delegationRight)
            return false
          const meteringPermissions = whatCanDelegatedUserDo({ collection: DB_COLLECTIONS.METERING, delegationRight: this.delegationRight })
          return meteringPermissions && meteringPermissions.canCreateNew
        },
        allowedToAddEvent() {
          if(!this.clipod)
            return false
          if(!this.clipod.isDelegatedAccess)
            return true
          if(!this.delegationRight)
            return false
          const meteringPermissions = whatCanDelegatedUserDo({ collection: DB_COLLECTIONS.EVENTS, delegationRight: this.delegationRight })
          return meteringPermissions && meteringPermissions.canCreateNew
        },
        timeframeText() {
          let textParts = []
          const monoSelected = this.monoTimeframes.filter(tf => this.selectedTimeframes.includes(tf))
          const biSelected = this.biTimeframes.filter(tf => this.selectedTimeframes.includes(tf))
          const impactSelected = this.impactTimeframes.filter(tf => this.selectedTimeframes.includes(tf))

          monoSelected.forEach(tf => textParts.push(this.label.forms[tf] || tf))

          if (this.biTimeframes.length > 0 && biSelected.length === this.biTimeframes.length) {
             textParts.push(this.label.forms.biHoraire || 'Bi-horaire')
          } else {
             biSelected.forEach(tf => textParts.push(this.label.forms[tf] || tf))
          }

          if (this.impactTimeframes.length > 0 && impactSelected.length === this.impactTimeframes.length) {
             textParts.push(this.label.forms.tarifImpact || 'Tarif Impact')
          } else {
             impactSelected.forEach(tf => textParts.push(this.label.forms[tf] || tf))
          }
          return textParts.join(', ')
        },
        directionText() {
          return this.selectedDirections.map(direction => this.getDirectionFriendlyName(direction)).join(', ')
        },
        // registerText() {
        //   if (!this.viewMultiplePods) {
        //     return this.selectedRegisters.map(registerId => this.availableRegisters.find(reg => reg.id == registerId).name).join(', ')
        //   }
        //   else {
        //     return this.selectedRegisters
        //   }
        // },
        aggregationText() {
          if (this.aggregation == 'QUARTER_H') return this.label.forms.quarter
          if (this.aggregation == 'HOUR') return this.label.forms.hour
          if (this.aggregation == 'DAY') return this.label.forms.day
          if (this.aggregation == 'WEEK') return this.label.forms.week
          if (this.aggregation == 'MONTH') return this.label.forms.month
          if (this.aggregation == 'YEAR') return this.label.forms.year
          else return ""
        },
        today() {
            return moment().format("YYYY-MM-DD");
        },
        currentDateContext() {
          if (!this.startDate || this.compareByYear) return '';
          
          const date = moment(this.startDate);
          date.locale('fr');

          let formatStr = '';
          
          switch (this.aggregation) {
            case 'YEAR':
              return 'Années disponibles';
            case 'MONTH':
              formatStr = 'YYYY'; 
              break;
            case 'WEEK':
            case 'DAY':
              formatStr = 'MMMM YYYY'; 
              break;
            // case 'HOUR':
            case 'QUARTER_H':
              formatStr = 'DD MMMM YYYY'; 
              break;
            default:
              return '';
          }
          
          const formattedDate = date.format(formatStr);
          return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
        },
        hasIncompletePeriods() {
          if(!this.groupedIncompletePeriods)
            return false

          return this.groupedIncompletePeriods.some(iP => iP.incompletePI.length > 0)
        },
        showHighFrequencyAggregations() {
            return this.hasHighFrequencyDataCurrently;
        },
        currentUnit() {
            if(this.showingDataInKWH)
                return 'kWh';
            switch(this.clipod.pod.energy.inputUnit) {
                case 'L':
                    return this.label.texts.liters;
                default:
                    return this.label.texts.mcube;
            }
        },
        selectedHighAggregation() {
          return this.aggregation == 'QUARTER_H' || this.aggregation == 'HOUR'
        },
        minDate() {
          if(!this.firstDataDate)
            return null
          if(this.compareByYear) {
            return moment().startOf('year').format('YYYY-MM-DD')
          }
          return moment(this.firstDataDate).format('YYYY-MM-DD')
        },
        maxDate() {
          if(!this.lastDataDate)
            return null
          if(this.compareByYear) {
            return moment().endOf('year').format('YYYY-MM-DD')
          }
          return moment(this.lastDataDate).format('YYYY-MM-DD')
        },
        atLeastOneRegisterSelected() {
          if(this.viewMultiplePods) {
            if(!this.multiplePodSelection)
              return false
            let multiplePodSelectionEntry = Object.entries(this.multiplePodSelection)
            return multiplePodSelectionEntry.some(podWSelectedRegisters => podWSelectedRegisters[1].registersIDs.length > 0)
          } else {
            return this.selectedRegisters && this.selectedRegisters.length > 0
          }
        },
        isMonthViewContext() {
          return this.aggregation === 'DAY' || this.aggregation === 'WEEK';
        },
        isWeekView: {
          get() {
            return this.aggregation === 'WEEK';
          },
          set(value) {
            this.changeAggregation(value ? 'WEEK' : 'DAY');
          }
        }
    },
    methods: {
        ...mapActions("labels", ["getLabel"]),
        getSCEFriendlyName(sce) {
          return getSCEFriendlyName(sce)
        },
        getDirectionFriendlyName(direction) {
          if(!KNOWN_DIRECTIONS.includes(direction))
            return
          return DIRECTION_MAPPING[direction]
        },
        getPodAvailableRegisters(pod) {
          let podInfos = this.availableRegistersPerPod.find(info => info.podID == pod.id)
          if(!podInfos)
            return []
          return podInfos.availableRegisters
        },
        onBenchmarkingClick() {
          if (!this.showBenchmarking) {
            this.showBenchmarking = true
            this.compareByYear = false
            this.viewMultiplePods = false
            this.loadTimeSeries('onBenchmarkingClick')
          }
        },
        resetSelectedSCE() {
          this.selectedSCE = this.availableSCE
        },
        redefineAvailableRegisters() {
          // redefine the availabled registers and select them
          if(!this.clipod)
            this.availableRegisters = []
          if(this.viewMultiplePods) {
            // set available registers per pod
            this.availableRegistersPerPod = []
            this.allClipods.forEach(clipod => {
              let availablePodRegisters = clipod.pod.variable.filter(v => {
                return this.selectedTimeframes.includes(v.timeframe) && this.selectedDirections.includes(v.direction)
              })
              this.availableRegistersPerPod.push({
                podID: clipod.pod.id,
                availableRegisters: availablePodRegisters
              })
              this.multiplePodSelection[clipod.pod.id].selected = availablePodRegisters.length != 0
              this.multiplePodSelection[clipod.pod.id].registersIDs = availablePodRegisters.map(aR => aR.id)
            })
          }
          else {
              this.availableRegisters = this.clipod.pod.variable.filter((v) => {
              // let canBeSelected =  v.serviceComponentElement && this.selectedTimeframes.includes(v.timeframe) && this.selectedDirections.includes(v.serviceComponentElement)
              return v.serviceComponentElement
            })
            this.selectedRegisters = this.availableRegisters.map(aR => aR.id)
            this.resetSelectedSCE()
          }
        },
        onSelectedTimeframesChange() {
          // this.redefineAvailableRegisters()
          this.loadTimeSeries('onSelectedTimeframesChange')
        },
        // Détermine à quelle "famille" de plage horaire appartient un timeframe donné.
        // Utilisé uniquement pour la vue 15' (QUARTER_H), où une seule famille peut être active à la fois.
        getTimeframeFamily(tf) {
          if (this.biTimeframes.includes(tf)) return 'bi'
          if (this.impactTimeframes.includes(tf)) return 'impact'
          if (tf === 'EX') return 'exclusif'
          return 'mono'
        },
        // Falls back to mono-timeframe when the daily view has no data for the timeframe carried over from 15' view
        fallbackToMonoTimeframeAfterDailySwitch() {
          if (this.monoTimeframes.length === 0) return false
          const alreadyOnMono = this.selectedTimeframes.length === this.monoTimeframes.length &&
            this.monoTimeframes.every(tf => this.selectedTimeframes.includes(tf))
          if (alreadyOnMono) return false
          this.selectedTimeframes = this.monoTimeframes.slice()
          this.loadTimeSeries('quarterHToDayFallback')
          return true
        },
        // Gère le clic sur une case individuelle du filtre "Plages horaires".
        // En vue 15', sélectionner un timeframe désélectionne automatiquement les autres familles.
        onTimeframeCheckboxChange(timeframe) {
          if (this.aggregation === 'QUARTER_H' && this.selectedTimeframes.includes(timeframe)) {
            const family = this.getTimeframeFamily(timeframe)
            this.selectedTimeframes = this.selectedTimeframes.filter(tf => this.getTimeframeFamily(tf) === family)
          }
          this.onSelectedTimeframesChange()
        },
        onSelectedDirectionsChange() {
          // this.redefineAvailableRegisters()
          this.loadTimeSeries('onSelectedDirectionsChange')
        },
        // convert data to another unit (ex: m3 to kWh)
        convertData() {
            this.convertingData = true
            let conversionValue = this.clipod.personalizedEnergyConversion ? this.clipod.personalizedEnergyConversion: this.clipod.pod.energy.conversionToKWH
            if(this.showingDataInKWH) {
                conversionValue = 1/conversionValue
            }
            let convertedRegistersData = [...this.registersData]
            convertedRegistersData.forEach(rD => rD.consumptions = rD.consumptions.map(value => {
              return Number((value * conversionValue).toFixed(3))
            }))
            this.registersData = []
            this.overallConsumptions = this.overallConsumptions.map(value => Number((value * conversionValue).toFixed(3)))
            // the order of the following 3 lines below is important
            this.showingDataInKWH = !this.showingDataInKWH
            this.registersData = convertedRegistersData
            this.buildPrintDataForCurrentView()
            this.convertingData = false
        },
        formatDateForCsv(date) {
          if (!date) {
            return ''
          }
          return moment(date).tz('Europe/Brussels').format('YYYY-MM-DD HH:mm:ss')
        },
        formatConsumptionIntervalForCsv(startDate, endDate) {
          if (!startDate) {
            return ''
          }

          const start = moment(startDate).tz('Europe/Brussels')
          const end = endDate
            ? moment(endDate).tz('Europe/Brussels')
            : moment(startDate).tz('Europe/Brussels').add(15, 'minutes')

          return `${start.format('YYYY-MM-DD')}, ${start.format('HH:mm')} - ${end.format('HH:mm')}`
        },
        normalizeCsvValue(value) {
          if (value === null || value === undefined || Number.isNaN(Number(value))) {
            return ''
          }
          return Number(Number(value).toFixed(3))
        },
        sanitizeCsvHeader(value, fallback) {
          const base = (value || fallback || 'column').toString().trim()
          const normalized = base
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-zA-Z0-9]+/g, '_')
            .replace(/^_+|_+$/g, '')
            .toLowerCase()

          return normalized || fallback || 'column'
        },
        getCsvTimeframeLabel(timeframe) {
          const normalizedTimeframe = (timeframe || 'TH').toUpperCase()

          switch (normalizedTimeframe) {
            case 'TH':
              return 'monohoraire'
            case 'PWR':
              return this.aggregation === 'QUARTER_H' ? 'quarthoraire' : this.sanitizeCsvHeader(normalizedTimeframe, 'timeframe')
            case 'PWR_EX':
              return this.aggregation === 'QUARTER_H' ? 'quarthoraire_exclusif_nuit' : this.sanitizeCsvHeader(normalizedTimeframe, 'timeframe')
            case 'HI':
              return 'heures_pleines'
            case 'LO':
              return 'heures_creuses'
            case 'PK':
              return 'heures_pics'
            case 'MD':
              return 'heures_mediums'
            case 'EC':
              return 'heures_ecos'
            case 'EX':
              return 'exclusif_nuit'
            default:
              return this.sanitizeCsvHeader(timeframe, 'timeframe')
          }
        },
        getCsvDirectionLabel(direction, register = null) {
          const candidates = []

          if (direction !== null && direction !== undefined) {
            candidates.push(direction)
          }

          if (register?.variableName) {
            candidates.push(register.variableName)
          }

          for (const candidate of candidates) {
            if (candidate === null || candidate === undefined) {
              continue
            }

            const normalized = candidate.toString().toLowerCase()
            if (normalized.includes('inj') || normalized.includes('injection') || normalized === '1' || normalized === 'one') {
              return 'injection'
            }
            if (normalized.includes('pre') || normalized.includes('prelev') || normalized === '0' || normalized === 'zero' || normalized === '2' || normalized === 'two') {
              return 'prelevement'
            }
          }

          return 'prelevement'
        },
        getCsvColumnSortOrder(register) {
          const timeframe = (register?.timeframe || 'TH').toUpperCase()
          const orderMap = { TH: 0, PK: 1, HI: 1, MD: 2, LO: 2, EC: 3 }
          const baseOrder = orderMap[timeframe] !== undefined ? orderMap[timeframe] : 9
          const isInjection = this.getCsvDirectionLabel(register?.direction, register) === 'injection'
          return baseOrder + (isInjection ? 10 : 0)
        },
        getCsvHeaderForRegister(register, fallbackIndex = 0) {
          const timeframeLabel = this.getCsvTimeframeLabel(register?.timeframe)
          const directionLabel = this.getCsvDirectionLabel(register?.direction, register)
          const baseHeader = timeframeLabel && directionLabel
            ? `${timeframeLabel}_${directionLabel}`
            : this.sanitizeCsvHeader(register?.variableName || null, `register_${fallbackIndex + 1}`)

          return baseHeader
        },
        getUniqueCsvHeader(register, seenHeaders, fallbackIndex = 0) {
          const baseHeader = this.getCsvHeaderForRegister(register, fallbackIndex)
          let header = baseHeader
          let suffix = 2

          while (seenHeaders.has(header)) {
            header = `${baseHeader}_${suffix}`
            suffix += 1
          }

          seenHeaders.add(header)
          return header
        },
        buildPrintDataForCurrentView() {
          if (this.viewMultiplePods || this.compareByYear || !this.clipod || !this.allDates || !Array.isArray(this.registersData)) {
            this.printData = []
            this.printFields = []
            return
          }

          const exportRegisters = this.aggregation === 'QUARTER_H'
            ? this.registersData.filter(register => (register?.timeframe || '').toUpperCase() !== 'TH')
            : this.registersData

          const sortedRegisters = [...exportRegisters].sort((a, b) => {
            const orderA = this.getCsvColumnSortOrder(a)
            const orderB = this.getCsvColumnSortOrder(b)

            if (orderA !== orderB) {
              return orderA - orderB
            }

            const timeframeA = this.getCsvTimeframeLabel(a?.timeframe)
            const timeframeB = this.getCsvTimeframeLabel(b?.timeframe)
            if (timeframeA !== timeframeB) {
              return timeframeA.localeCompare(timeframeB)
            }

            const directionA = this.getCsvDirectionLabel(a?.direction)
            const directionB = this.getCsvDirectionLabel(b?.direction)
            if (directionA !== directionB) {
              return directionA === 'prelevement' ? -1 : 1
            }

            return (a?.variableName || '').localeCompare(b?.variableName || '')
          })

          const headers = ['ean', 'date', 'unite', 'consommation_globale']
          if (this.aggregation === 'QUARTER_H') {
            headers[1] = 'plage_consommation'
          }
          const seenHeaders = new Set(headers)
          const registerHeaders = []

          sortedRegisters.forEach((register, index) => {
            const header = this.getUniqueCsvHeader(register, seenHeaders, index)
            registerHeaders.push(header)
          })

          headers.push(...registerHeaders)

          const rows = []
          const periodCount = Math.max(0, this.allDates.length - 1)

          for (let index = 0; index < periodCount; index++) {
            const periodStart = this.allDates[index]
            const periodEnd = this.allDates[index + 1]
            const row = {
              ean: this.clipod?.pod?.EAN || '',
              date: this.formatDateForCsv(periodStart),
              unite: this.currentUnit || this.clipod?.pod?.energy?.inputUnit || ''
            }

            if (this.aggregation === 'QUARTER_H') {
              row.plage_consommation = this.formatConsumptionIntervalForCsv(periodStart, periodEnd)
            } else {
              row.date = this.formatDateForCsv(periodStart)
            }

            row.consommation_globale = this.normalizeCsvValue(this.overallConsumptions?.[index])

            sortedRegisters.forEach((register, registerIndex) => {
              row[registerHeaders[registerIndex]] = this.normalizeCsvValue(register?.consumptions?.[index])
            })

            rows.push(row)
          }

          this.printData = rows
          this.printFields = headers
        },
        // formatDataToKWH(registersData, podID) {
        //   console.log(registersData)
        //   console.log(podID)
        // },
        onSelectedSCEChange() {
          // setTimeout(() => this.loadTimeSeries('onSelectedRegistersChange'), 15);
          this.loadTimeSeries('onSelectedTimeframesChange')
        },
        async onPodSelected(clipod) {
          if(!clipod) {
            this.clipod = null
            this.loadingData = false
            this.registersData = []
            return
          }
          this.aggregation = "MONTH"
          this.showingDataInKWH = clipod.pod.energy.energyName === "elec"
          if(clipod.pod.energy.energyName == "elec") {
              clipod.pod.variable.sort((a,b) => {
                  const indexOfA = this.label.forms.mappingRegister.indexOf(a.name.toLowerCase())
                  const indexOfB = this.label.forms.mappingRegister.indexOf(b.name.toLowerCase())
                  if(indexOfA >= 0 ) {
                      if(indexOfB >= 0) {
                          return indexOfA - indexOfB
                      } else {
                          return -1;
                      }
                  } else {
                      if(indexOfB >= 0) {
                          return 1;
                      } else {
                          return a.name < b.name ? -1 : 1
                      }
                  }
              })
          }
          this.clipod = clipod

          this.setSmartTfSelection()
          this.setAllDirections()

          if(this.clipod.pod.variable.length > 0) {
              this.selectedRegisters = this.clipod.pod.variable.filter(v => v.serviceComponentElement).map(v => v.id)
              this.resetSelectedSCE()
              this.redefineAvailableRegisters()
              this.startDate = new Date();
              this.changeAggregation('MONTH')
          }
          else {
              this.selectedRegisters = []
              this.resetSelectedSCE()
          }
          // this.resetMPSelection()
          await this.loadDatesOfFirstAndLastData()
          this.loadTimeSeries('onPodSelected')
        },
        onClipodsLoaded(clipods) {
          if (!clipods) return;
          for(let clipod of clipods) {
              if(clipod.pod && clipod.pod.variable) {
                clipod.pod.variable = sortRegisters(clipod.pod.variable)
              }
            }
          this.allClipods = clipods
          // this.resetMPSelection()
          // this.redefineAvailableRegisters()
        },
        // resetMPSelection() {
        //   for(let clipod of this.allClipods) {
        //     this.multiplePodSelection[clipod.pod.id] = {
        //       selected: clipod.pod.id == this.clipod.pod.id,
        //       pod: clipod.pod,
        //       registersIDs: clipod.pod.variable.map(v => v.id)
        //     }
        //   }
        // },
        // obsolete
        // loadGraphEvents() {
        //   if (this.viewMultiplePods || this.compareByYear || ["QUARTER_H", 'HOUR'].includes(this.aggregation) || !this.clipod || !this.clipod.pod.location) {
        //     this.eventsWithIndex = []
        //   } else {
        //     EventService.graphEvents(
        //       [this.clipod.pod.location.id],
        //       new Date(this.startDate),
        //       new Date(this.endDate),
        //       this.aggregation
        //     ).then(
        //       events => this.eventsWithIndex = events
        //     )
        //   }
        // },
        // changeHistory(value) {
        //   // Avancer ou reculer dans l'historique
        //   this.historyPosition += value
        //   const filters = this.historyStack[this.historyPosition]

        //   // Modifier les filtres
        //   this.compareByYear = filters.compareByYear
        //   this.viewMultiplePods = filters.viewMultiplePods
        //   this.showBenchmarking = filters.showBenchmarking

        //   this.user._id = filters.userId
        //   this.selectedRegisters = filters.selectedRegisters
        //   this.selectedSCE = filters.selectedSCE
        //   this.selectedDirections = filters.selectedDirections
        //   this.selectedTimeframes = filters.selectedTimeframes
        //   this.availableRegisters = filters.availableRegisters
        //   this.multiplePodSelection = JSON.parse(filters.multiplePodSelection)
        //   this.clipod = filters.clipod
        //   this.aggregation = filters.aggregation
        //   this.startDate =  filters.startDate
        //   this.endDate =  filters.endDate
        //   this.firstDataDate = filters.firstDataDate
        //   this.lastDataDate = filters.lastDataDate

        //   this.showMeteo = filters.showMeteo

        //   this.$refs.podSelection.selectPod(this.clipod.pod, false)

        //   this.loadTimeSeries('changeHistory')
        // },
        // shiftDatePeriod(direction) {
        //   if (this.compareByYear || !['QUARTER_H', 'HOUR'].includes(this.aggregation)) return;
          
        //   let shiftMs = 86400000;
        //   if (this.aggregation === 'QUARTER_H') {
        //     shiftMs = 3600000;
        //   }
          
        //   let newStart = moment(this.startDate).add(direction * shiftMs, 'milliseconds');
        //   let newEnd = moment(this.endDate).add(direction * shiftMs, 'milliseconds');
        //   if (direction < 0 && newStart.isSameOrBefore(this.firstDataDate)) {
        //       this.aggregation = 'DAY';
        //       newStart = moment(this.startDate).subtract(1, 'days');
        //       newEnd = moment(this.startDate);
        //   } else if (direction > 0 && newEnd.isSameOrAfter(this.lastDataDate)) {
        //       this.aggregation = 'DAY';
        //       newStart = moment(this.endDate).add(1, 'days');
        //       newEnd = moment(this.endDate).add(2, 'days');
        //   }
        //   this.startDate = newStart.toDate();
        //   this.endDate = newEnd.toDate();
        //   this.loadTimeSeries('shiftDatePeriod');
        // },
        // loadTimeSeries(source) {
        loadTimeSeries() {
            this.showModalIndex = false
            this.showModalEvent = false

            this.checkThatDatesAreWithinBounds('load ts')

            // Check taille données
            this.tooManyData = false
            if (this.selectedHighAggregation === true) {
              const difference = moment(this.endDate).diff(moment(this.startDate), 'd')
              if (difference > 5) {
                this.tooManyData = true
                return
              }
            }
            // // History Stack
            // if (!['changeHistory', 'addIndex', 'addEvent', 'refresh'].includes(source)) {
            //   // if history position not at the end, delete the following filters

            //   // Create filters
            //   const filters = {
            //     compareByYear: this.compareByYear,
            //     viewMultiplePods: this.viewMultiplePods,
            //     showBenchmarking: this.showBenchmarking,

            //     userId: this.user._id,
            //     selectedRegisters: this.selectedRegisters,
            //     selectedSCE: this.selectedSCE,
            //     selectedDirections: this.selectedDirections,
            //     selectedTimeframes: this.selectedTimeframes,
            //     availableRegisters: this.availableRegisters,
            //     multiplePodSelection: JSON.stringify(this.multiplePodSelection),
            //     clipod: this.clipod,
            //     aggregation: this.aggregation,
            //     startDate: this.startDate,
            //     endDate: this.endDate,
            //     firstDataDate: this.firstDataDate,
            //     lastDataDate: this.lastDataDate,

            //     showMeteo: this.showMeteo
            //   }

            //   // Prevent loadTimeseries if same filters
            //   if (this.historyStack.length > 0) {
            //     if (JSON.stringify(filters) === JSON.stringify(this.historyStack[this.historyPosition])) {
            //       // console.log(filters)
            //       // console.log(this.historyStack[this.historyStack.length-1])
            //       return
            //     }
            //   }

            //   // Calculate position and push
            //   this.historyStack.length >= 10 && this.historyStack.shift() // Limiter à un historique de 10
            //   // if not on the last history stack element, remove the next ones
            //   if(this.historyPosition < this.historyStack.length-1) {
            //     this.historyStack.splice(this.historyPosition + 1)
            //   }
            //   this.historyStack.push(filters)
            //   this.historyPosition = this.historyStack.length-1
            // }

            // check that at least one register selected
            // if view in on multiple pod mode, selected registers are in the "multiplepodselection" array
            // if view is on any other mode, selected registers are in the "selectedregisters" array

            // (temporarily?) removing this check due to the information of SCE not being provided 
            // by the DataPlatform at this stage.
            // /!\ the DataPlatform should return the correct SC/SCE before going in production, even 
            // if it is not currently used in the portal (future usage).
            /*
            if(!this.atLeastOneRegisterSelected) {
              this.loadingData = false
              return this.registersData = []
            }
            */

            // loadEvents
            // this.loadGraphEvents()
            if (this.selectedTimeframes.length === 0 || this.selectedDirections.length === 0) {
              this.allDates = [];
              this.overallConsumptions = [];
              this.registersData = [];
              this.loadingData = false;
              return;
            }
            
            this.loadingData = true
            // call the right method to load consumption data
            if(this.compareByYear) {
                this.loadDataForHistoryComparison()
            }
            else {
              if(this.viewMultiplePods) {
                this.loadDataForMultiPodView()
              } else {
                this.loadBasicTsData()
              }
            }
            // this.refreshSlider()
        },
        async loadDataForHistoryComparison() {
          let years = []
          let year = moment().subtract(2, 'years').year()
          for(let i = 0; i < 3; i++) {
              years.push(year)
              year++
          }
          let promises = []
          this.fromMonth = moment(this.startDate).month()+1
          this.toMonth = moment(this.endDate).month()+1
          this.fromDay = moment(this.startDate).date()
          this.toDay = moment(this.endDate).date()
          for(let i = 0; i < 3; i++) {
              let startDate = moment(`${years[i]}-${this.fromMonth}-${this.fromDay}`, "YYYY-MM-DD")
              if(!startDate.isValid())
                  startDate = moment(`${years[i]}-${this.fromMonth+1}-01`, "YYYY-MM-DD")
              let endDate = moment(`${years[i]}-${this.toMonth}-${this.toDay}`, "YYYY-MM-DD")
              if(!endDate.isValid())
                  endDate = moment(`${years[i]}-${this.toMonth}-${this.toDay-1}`, "YYYY-MM-DD")
              let promise = TimeSeriesService.loadTimeSeries(
                {
                  clientID: this.user._id,
                  variableIDs: this.selectedRegisters,
                  podID: this.clipod.pod.id,
                  dateFrom: new Date(startDate.format("YYYY-MM-DD")),
                  date: new Date(endDate.format("YYYY-MM-DD")),
                  aggregation: this.aggregation,
                  needAllDates: false,
                  needBenchmarkingCurve: false,
                  needCostEstimations: false,
                  needOverallConsumptions: true,
                  needIndividualRegistersData: false
                }
              )
              promises.push(promise)
          }
          this.yearsToCompare = years
          const data = await Promise.all(promises)
          // check if no data to display
          const noDataToShow = data.every(
            dataByYear => {
              return dataByYear.overallConsumptions.every(cons => {
                return cons == 0
              })
          })
          if(noDataToShow) {
            // no data to show
            this.allDates = []
            this.overallConsumptions = []
            this.registersData = []
            this.loadingData = false
            return
          }
          this.loadingData = false
          for(let i in years) {
            data[i].year = years[i]
          }
          this.registersData = data
        },
        async loadDataForMultiPodView() {
          let promises = []
          const startDate = new Date(this.startDate)
          const endDate = new Date(this.endDate)
          for(let podId in this.multiplePodSelection) {
            if(this.multiplePodSelection[podId].selected) {
              
              let filteredRegisters = this.multiplePodSelection[podId].registersIDs
                .map(rID => this.getVariableDetailsFromID(podId, rID))
                .filter(register => this.selectedTimeframes.includes(register.timeframe))
                .filter(register => this.selectedDirections.includes(register.direction))

              if (this.aggregation === 'QUARTER_H') {
                  filteredRegisters = this.allClipods.find(c => c.pod.id === podId).pod.variable
                      .filter(v => ['PWR', 'PWR_EX'].includes(v.timeframe) && this.selectedDirections.includes(v.direction));
              }

              if(filteredRegisters.length > 0) {
                promises.push(TimeSeriesService.loadTimeSeries(
                {
                  clientID: this.user._id,
                  variableIDs: filteredRegisters.map(r => r.id),
                  podID: podId,
                  dateFrom: startDate,
                  date: endDate,
                  aggregation: this.aggregation,
                  needAllDates: true,
                  needBenchmarkingCurve: false,
                  needCostEstimations: false,
                  needOverallConsumptions: true,
                  needIndividualRegistersData: false
                }))
              }
            }
          }
          let timeseriesData = await Promise.all(promises)
          this.manageLoadedTs(timeseriesData)
        },
        async loadBasicTsData() {
          let promises = []
          const startDate = new Date(this.startDate)
          const endDate = new Date(this.endDate)

          let apiVariableIDs = this.selectedRegisters;
          let apiTimeframes = this.selectedTimeframes;

          if (this.aggregation === 'QUARTER_H') {
              apiTimeframes = ['PWR', 'PWR_EX'];
              if (this.clipod) {
                  apiVariableIDs = this.clipod.pod.variable
                      .filter(v => v.serviceComponentElement && ['PWR', 'PWR_EX'].includes(v.timeframe) && this.selectedDirections.includes(v.direction))
                      .map(v => v.id);
              }
          }
          promises.push(TimeSeriesService.loadTimeSeries(
            {
              clientID: this.user._id,
              variableIDs: apiVariableIDs,
              selectedSCE: this.selectedSCE,
              timeframes: apiTimeframes,
              directions: this.selectedDirections,
              podID: this.clipod.pod.id,
              dateFrom: startDate,
              date: endDate,
              aggregation: this.aggregation,
              needAllDates: true,
              needBenchmarkingCurve: this.showBenchmarking,
              needCostEstimations: !this.showBenchmarking,
              needOverallConsumptions: true
            }
          ))
          let timeseriesData = await Promise.all(promises)
          this.manageLoadedTs(timeseriesData)
        },
        getVariableDetailsFromID(podID, variableID) {
          if(!this.allClipods)
            return null
          const clipod = this.allClipods.find(clipod => clipod.pod.id == podID)
          if(!clipod)
            return null
          return clipod.pod.variable.find(variable => variable.id == variableID)
        },
        registerTimeframeIsSelected(register) {
          return this.selectedTimeframes.includes(register.timeframe)
        },
        registerDirectionIsSelected(register) {
          return  this.selectedDirections.includes(register.direction)
        },
        manageLoadedTs(timeseriesData) {
            this.loadingData = false
            const shouldCheckDailyFallback = this.pendingDailyFallbackCheck
            this.pendingDailyFallbackCheck = false
            const prevHasHighFrequencyData = this.hasHighFrequencyDataCurrently
            
          // Check for high frequency data (quarter-hour) using multiple signals:
          // 1) explicit flag on the pod `includeIntervalReadings`
          // 2) presence of variables with timeframe 'TH' or 'PWR' on the pod
          // 3) loaded timeseries registers containing 'TH'/'PWR' timeframe
          const podHasIntervalFlag = !!(this.clipod && this.clipod.pod && this.clipod.pod.includeIntervalReadings === true)
          const podHasIntervalVariables = !!(
            this.clipod && this.clipod.pod && Array.isArray(this.clipod.pod.variable) &&
            this.clipod.pod.variable.some(v => ['TH', 'PWR'].includes((v.timeframe || '').toUpperCase()))
          )
          const timeseriesHasIntervalRegisters = !!(
            Array.isArray(timeseriesData) && timeseriesData.length > 0 &&
            Array.isArray(timeseriesData[0].registers) &&
            timeseriesData[0].registers.some(r => ['TH', 'PWR'].includes((r.timeframe || '').toUpperCase()))
          )

          this.hasHighFrequencyDataCurrently = podHasIntervalFlag || podHasIntervalVariables || timeseriesHasIntervalRegisters

            // Reset aggregation when no more high frequency data
            if (prevHasHighFrequencyData && !this.hasHighFrequencyDataCurrently && this.selectedHighAggregation) {
                this.changeAggregation('DAY')
                this.hasHighFrequencyDataCurrently = true
                return
            }

            if(this.viewMultiplePods) {
              let dataByPod = []
              // ajouter les pods dans la liste
              for(let podID in this.multiplePodSelection) {
                  if(this.multiplePodSelection[podID].selected && this.multiplePodSelection[podID].registersIDs.length > 0) {
                    dataByPod.push({
                    pod: this.multiplePodSelection[podID].pod,
                    registersData: null,
                    podCustomName: this.allClipods.find(clipod => clipod.pod.id == this.multiplePodSelection[podID].pod.id).podCustomName
                  })
                }
              }
              if(!timeseriesData[0]) {
                // no data to show
                this.allDates = []
                this.overallConsumptions = []
                this.registersData = []
                if (shouldCheckDailyFallback && this.fallbackToMonoTimeframeAfterDailySwitch()) return
                return
              }
              // parcourir les données chargées par registres et enlever les extrémités sans données
              let indexOfFirstData = null
              let indexOfLastData = null
              timeseriesData.forEach(tsData => {
                const indexOfFirstAndLastData = this.indexOfFirstAndLastData(tsData)
                if(indexOfFirstAndLastData.indexOfFirstData != null) {
                  if(indexOfFirstData == null || indexOfFirstAndLastData.indexOfFirstData < indexOfFirstData) {
                    indexOfFirstData = indexOfFirstAndLastData.indexOfFirstData
                  }
                }
                if(indexOfFirstAndLastData.indexOfLastData != null) {
                  if(indexOfLastData == null || indexOfFirstAndLastData.indexOfLastData > indexOfLastData) {
                    indexOfLastData = indexOfFirstAndLastData.indexOfLastData
                  }
                }
              })
              if(indexOfLastData == null) {
                // tell user that there is no data to show
                this.allDates = []
                this.registersData = []
                if (shouldCheckDailyFallback && this.fallbackToMonoTimeframeAfterDailySwitch()) return
                return
              }
              // Don't cut the day for high frequency data to keep the 00:00 data
              if (this.aggregation === 'QUARTER_H') {
                indexOfFirstData = 0;
                indexOfLastData = timeseriesData[0].allDates.length - 2;
              }
              // slice data, dates and overall consumptions to keep the parts with data
              // --  also fill in the array of incomplete periods grouped by pod
              let groupedIncompletePeriods = []
              // "tsData" contains only one pod's timeseries informations
              timeseriesData.forEach(tsData => {
                // remove useless data parts (parts with only 0 values)
                tsData.allDates = tsData.allDates.slice(indexOfFirstData, indexOfLastData + 2)
                tsData.overallConsumptions = tsData.overallConsumptions.slice(indexOfFirstData, indexOfLastData + 1)

                // find all the incomplete periods indexes
                // indexesOfIncompletePeriods gives them by register
                // so we group them by pod after retrieving them
                let incompletePeriodsByRegister = this.indexesOfIncompletePeriods(tsData)
                let incompletePeriodsByPod = {
                  podID: this.podIDOfRegister(tsData.registers[0].variableID),
                  // indexes of incomplete periods
                  incompletePI: []
                }
                // grouping the incomplete periods by pod
                incompletePeriodsByRegister.forEach(iPByRegister => {
                  iPByRegister.incompletePI.forEach(index => {
                    if(!incompletePeriodsByPod.incompletePI.includes(index)) {
                      incompletePeriodsByPod.incompletePI.push(index)
                    }
                  })
                })
                groupedIncompletePeriods.push(incompletePeriodsByPod)
              })
              // lier les données groupées par registres à leur POD respectif
              timeseriesData.forEach(tsData => {
                const firstVariableID = tsData.registers[0].variableID

                const tsDataPodID = Object.entries(this.multiplePodSelection).find(entry => {
                  return entry[1].pod.variable.some(v =>
                    v.id == firstVariableID
                  )
                })[0]
                dataByPod.find(podInfos => podInfos.pod.id == tsDataPodID).registersData = {
                  allDates: tsData.allDates,
                  registers: tsData.registers
                }
                dataByPod.find(podInfos => podInfos.pod.id == tsDataPodID).overallConsumptions = tsData.overallConsumptions
              })

              // parcoure dataByPod et met toutes les données en kWh
              dataByPod.forEach(dataWPod => {
                if(dataWPod.pod.energy.conversionToKWH != 1) {
                  const conversionValue = dataWPod.pod.energy.conversionToKWH
                  if(dataWPod.overallConsumptions) {
                    dataWPod.overallConsumptions = dataWPod.overallConsumptions.map(value => value * conversionValue)
                  }
                }
                
                // EX and classical meters filtering for 15' view (QUARTER_H) for multi pods
                if (this.aggregation === 'QUARTER_H') {
                    if (dataWPod.registersData && dataWPod.registersData.registers) {
                        dataWPod.registersData.registers = dataWPod.registersData.registers.filter(reg => {
                            const podVar = dataWPod.pod.variable.find(v => v.id === reg.variableID);
                            const timeframe = (podVar && podVar.timeframe) || reg.timeframe;

                            if (timeframe === 'PWR' || timeframe === 'PWR_EX') {
                                const isEx = timeframe === 'PWR_EX';
                                const wantEx = this.selectedTimeframes.includes('EX');
                                const wantStandard = this.selectedTimeframes.some(tf =>
                                    tf === 'TH' || this.biTimeframes.includes(tf) || this.impactTimeframes.includes(tf)
                                );

                                if (isEx && !wantEx) return false;
                                if (!isEx && !wantStandard) return false;
                            }
                            return true;
                        });
                    }
                }
              })

              let overallConsumptions = []
              for(let i = 0; i < dataByPod[0].overallConsumptions.length; i++) {
                overallConsumptions[i] = 0
              }
              dataByPod.forEach(dataWPod => {
                // calculate the overall consumption (for all pods)
                for(let i in dataWPod.overallConsumptions) {
                  overallConsumptions[i] += dataWPod.overallConsumptions[i]
                }
              })

              // lier les variables calculées aux variables du composant "mydata"
              this.showingDataInKWH = true
              
              const hasData = dataByPod.some(podData => 
                  podData.registersData && podData.registersData.registers && podData.registersData.registers.some(reg => 
                      reg.consumptions.some(val => val !== null && val !== undefined && !isNaN(Number(val)) && Number(val) !== 0)
                  )
              );
              
              if (!hasData) {
                  this.allDates = [];
                  this.overallConsumptions = [];
                  this.registersData = [];
                  if (shouldCheckDailyFallback && this.fallbackToMonoTimeframeAfterDailySwitch()) return
                  return;
              }

              this.allDates = timeseriesData[0].allDates
              this.overallConsumptions = overallConsumptions
              this.groupedIncompletePeriods = groupedIncompletePeriods
              this.registersData = dataByPod
              // todo formatter les données en kwh
            } else {
              // print data
              // this.printFields = ["ean", "date", "unit"]
              // this.printData = timeseriesData[0].allDates.map((date, index) => {
              //   let record = { date }
              //   record.ean = this.clipod.pod.EAN
              //   // record.fluid = this.clipod.pod.fluid
              //   record.unit = this.clipod.pod.energy.inputUnit
              //   timeseriesData[0].registers.forEach(register => {
              //     record[register.variableName] = register.consumptions[index]
              //     this.printFields.push(register.variableName)
              //   })
              //   return record
              // })

              // unpack the result
              timeseriesData = timeseriesData[0]
              this.loadingData = false;
              if(!timeseriesData) {
                  this.allDates = [];
                  this.overallConsumptions = [];
                  this.registersData = [];
              }
              // remove extremities without data
              const indexOfFirstAndLastData = this.indexOfFirstAndLastData(timeseriesData)
              let indexOfLastData = indexOfFirstAndLastData.indexOfLastData
              let indexOfFirstData = indexOfFirstAndLastData.indexOfFirstData
              if(indexOfLastData == null) {
                  // todo tell user that there is no data to show
                  this.allDates = []
                  this.overallConsumptions = []
                  this.registersData = []
                  if (shouldCheckDailyFallback && this.fallbackToMonoTimeframeAfterDailySwitch()) return
                  return
              }
              if (this.aggregation === 'QUARTER_H') {
                indexOfFirstData = 0;
                indexOfLastData = timeseriesData.allDates.length - 2;
              }
              // slice data, dates and overall consumptions to keep the parts with data
              for(let rIndex in timeseriesData.registers) {
                  timeseriesData.registers[rIndex].consumptions = timeseriesData.registers[rIndex].consumptions.slice(indexOfFirstData, indexOfLastData + 1)
              }
              this.allDates = timeseriesData.allDates.slice(indexOfFirstData, indexOfLastData + 2)

              const selectedTimeframes = Array.isArray(this.selectedTimeframes)
                ? this.selectedTimeframes.map(tf => (tf || '').toString().toUpperCase())
                : []

              const getRegisterTimeframe = (register) => {
                const podVariable = this.clipod && this.clipod.pod && Array.isArray(this.clipod.pod.variable)
                  ? this.clipod.pod.variable.find(variable => variable.id === register.variableID)
                  : null
                return ((podVariable && podVariable.timeframe) || register.timeframe || '').toString().toUpperCase()
              }

              const shouldUseThOnly = selectedTimeframes.includes('TH')
              const selectedBaseTimeframes = shouldUseThOnly
                ? ['TH']
                : selectedTimeframes.filter(tf => tf !== 'EX')

              const overallRegisters = timeseriesData.registers.filter(register => {
                const timeframe = getRegisterTimeframe(register)
                if (timeframe === 'EX') {
                  return selectedTimeframes.includes('EX')
                }
                return selectedBaseTimeframes.includes(timeframe)
              })

              if (overallRegisters.length > 0 && Array.isArray(overallRegisters[0].consumptions)) {
                const overallConsumptions = new Array(overallRegisters[0].consumptions.length).fill(0)
                overallRegisters.forEach(register => {
                  register.consumptions.forEach((value, index) => {
                    overallConsumptions[index] += (value === null || value === undefined || Number.isNaN(Number(value))) ? 0 : Number(value)
                  })
                })
                this.overallConsumptions = overallConsumptions
              } else {
                this.overallConsumptions = timeseriesData.overallConsumptions.slice(indexOfFirstData, indexOfLastData + 1)
              }
              
              // EX and classical meters filtering for 15' view (QUARTER_H for single pod
              if (this.aggregation === 'QUARTER_H') {
                  timeseriesData.registers = timeseriesData.registers.filter(reg => {
                      const podVar = this.clipod.pod.variable.find(v => v.id === reg.variableID);
                      const timeframe = (podVar && podVar.timeframe) || reg.timeframe;

                      if (timeframe === 'PWR' || timeframe === 'PWR_EX') {
                          const isEx = timeframe === 'PWR_EX';
                          const wantEx = this.selectedTimeframes.includes('EX');
                          // Le PWR (Mono-horaire) sert aussi de base au coloriage bi-horaire/tarif impact,
                          // donc on le garde dès que l'une de ces familles est sélectionnée, même sans "TH".
                          const wantStandard = this.selectedTimeframes.some(tf =>
                              tf === 'TH' || this.biTimeframes.includes(tf) || this.impactTimeframes.includes(tf)
                          );

                          if (isEx && !wantEx) return false;
                          if (!isEx && !wantStandard) return false;
                      }
                      return true;
                  });
              }

              if(this.showBenchmarking) {
                this.benchmarkingCurve = timeseriesData.benchmarkingCurve
              }

              // Adjust event indices to match the sliced allDates array
              this.eventsWithIndex = timeseriesData.eventsForChart.map(eventWithIndex => ({
                event: eventWithIndex.event,
                index: eventWithIndex.index - indexOfFirstData
              })).filter(eventWithIndex => eventWithIndex.index >= 0 && eventWithIndex.index < this.allDates.length - 1)

              this.groupedIncompletePeriods = this.indexesOfIncompletePeriods(timeseriesData)
              
              const hasData = timeseriesData.registers.some(reg => 
                  reg.consumptions.some(val => val !== null && val !== undefined && !isNaN(Number(val)) && Number(val) !== 0)
              );
              
              if (!hasData) {
                  this.allDates = [];
                  this.overallConsumptions = [];
                  this.registersData = [];
                  if (shouldCheckDailyFallback && this.fallbackToMonoTimeframeAfterDailySwitch()) return
                  return;
              }

              this.registersData = timeseriesData.registers
              this.buildPrintDataForCurrentView()
              // todo formatter les données en kwh
            }
        },
        // finds the first and last indexes where there is data != 0 in an object as returned by the api endpoint "timeseries"
        indexOfFirstAndLastData(timeseriesData) {
          let indexOfFirstData = null
          let indexOfLastData = null
          if(!timeseriesData.registers[0]) {
            return {
              indexOfFirstData: null,
              indexOfLastData: null
            }
          }
          indexOfFirstData = timeseriesData.registers[0].indexOfFirstCons
          indexOfLastData = timeseriesData.registers[0].indexOfLastCons
          timeseriesData.registers.forEach(registerInfo => {
            if(registerInfo.indexOfFirstCons != null) {
              if(indexOfFirstData == null || registerInfo.indexOfFirstCons < indexOfFirstData) {
                indexOfFirstData = registerInfo.indexOfFirstCons
              }
            }
            if(registerInfo.indexOfLastCons != null) {
              if(indexOfLastData == null || registerInfo.indexOfLastCons > indexOfLastData)
                indexOfLastData = registerInfo.indexOfLastCons
            }
          })
          return {
            indexOfFirstData: indexOfFirstData,
            indexOfLastData: indexOfLastData
          }
        },
        // find the indexes of consumptions that are incomplete
        indexesOfIncompletePeriods(timeseriesData) {
          let incompletePeriodsByRegister = []
          timeseriesData.registers.forEach(rData => {
            let registerInfos = {
              registerID: rData.variableID,
              // indexes of incomplete periods for this register
              incompletePI: []
            }
            if(!rData.firstPeriodIsComplete && rData.indexOfFirstCons !== null) {
              registerInfos.incompletePI.push(rData.indexOfFirstCons)
            }
            if(!rData.lastPeriodIsComplete && rData.indexOfLastCons !== null) {
              registerInfos.incompletePI.push(rData.indexOfLastCons)
            }

            incompletePeriodsByRegister.push(registerInfos)
          })
          return incompletePeriodsByRegister
        },
        // onDateChange() {
        //   // this.startDate = moment(this.startDate).format("YYYY-MM-DD")
        //   // this.recalculateEndDate()
        //   if(this.clipod)
        //     this.loadTimeSeries('onDateChange')
        // },
        onCompareClick() {
          if (!this.compareByYear) {
            this.compareByYear = true
            this.showBenchmarking = false
            this.viewMultiplePods = false

            let date
            const activeStartDate = moment(this.startDate)
            const startOfYear = moment().startOf('year')
            const endOfYear = moment().endOf('year')

            // check that start date is within current year
            if(activeStartDate < startOfYear) {
              this.startDate = startOfYear.toDate()
            } else {
              if(activeStartDate > endOfYear) {
                this.startDate = startOfYear.toDate()
              }
            }
            // set end date to have a good range of data
            switch(this.aggregation) {
                case 'QUARTER_H':
                    date = moment(this.startDate).add(1, 'day');
                    break;
                case 'HOUR':
                    date = moment(this.startDate).add(1, 'day');
                    break;
                case 'DAY':
                    date = moment(this.startDate).add(1, 'month');
                    break;
                // case week, month, year
                case 'WEEK':
                  date = moment(this.startDate).add(14, 'weeks')
                  break;
                default:
                    date = moment().endOf('year')
                    break;
            }

            this.minStartDate = moment().startOf('year').format("YYYY-MM-DD")
            this.maxEndDate = date > moment().endOf('year') ? moment().endOf('year').format("YYYY-MM-DD") : date.format("YYYY-MM-DD")

            if(date > moment(this.maxEndDate)) {
              date = moment(this.maxEndDate)
            }
            this.endDate = date.toDate()

            this.loadTimeSeries('onCompareClick')
          }
        },
        loadedAllRegisters(allRegistersIDs) {
            this.allRegistersIDs = allRegistersIDs;
        },
        changeAggregation(value) {
          this.tooManyData = false;
        
          const referenceDate = moment(this.startDate);

          switch (value) {
            case 'QUARTER_H':
              this.startDate = referenceDate.startOf('day').toDate();
              this.endDate = moment(this.startDate).add(1, 'days').toDate();
              // Only one timeframe (Mono-horaire, bi-horaire, tarif impact, exclusif nuit) can be selected for QUARTER_H aggregation
              if (this.selectedTimeframes.length > 0) {
                const family = this.getTimeframeFamily(this.selectedTimeframes[0])
                this.selectedTimeframes = this.selectedTimeframes.filter(tf => this.getTimeframeFamily(tf) === family)
              }
              break;
            case 'WEEK':
            case 'DAY':
              // Coming back from 15' view: flag a possible fallback, see manageLoadedTs
              if (value === 'DAY' && this.aggregation === 'QUARTER_H') {
                this.pendingDailyFallbackCheck = true;
              }
              this.startDate = referenceDate.startOf('month').toDate();
              this.endDate = moment(this.startDate).add(1, 'months').toDate();
              break;

            case 'MONTH':
              this.startDate = referenceDate.startOf('year').toDate();
              this.endDate = moment(this.startDate).add(1, 'years').toDate();
              break;

            case 'YEAR':
              if (this.firstDataDate) {
                this.startDate = moment(this.firstDataDate).startOf('year').toDate();
              } else {
                this.startDate = moment().startOf('year').toDate();
              }
              this.endDate = moment().endOf('year').toDate();
              break;
          }

          this.aggregation = value;
          this.loadTimeSeries('changeAggregation');
        },
        goUpAggregation() {
          let nextAggr = null;
          
          switch(this.aggregation) {
            case 'QUARTER_H':
              nextAggr = 'DAY';
              break;
            case 'DAY':
              nextAggr = 'MONTH';
              break;
            case 'WEEK':
              nextAggr = 'MONTH';
              break;
            case 'MONTH':
              nextAggr = 'YEAR';
              break;
          }
          
          if (nextAggr) {
            this.changeAggregation(nextAggr);
          }
        },
        isPodSelected(pod) {
          return this.multiplePodSelection[pod.id].selected
        },
        async onViewMultiplePodsSelected() {
          this.viewMultiplePods = true
          this.compareByYear = false
          this.showBenchmarking = false
          this.setAllTimeframes()
          this.setAllDirections()
          // this.redefineAvailableRegisters()
          await this.loadDatesOfFirstAndLastData()

          this.loadTimeSeries('onViewMultiplePodsSelected')
        },
        async onMPPodChange(source) {
          await this.loadDatesOfFirstAndLastData('onMPPodChange')
          this.loadTimeSeries(source)
        },
        onMPRegistersChange(multiplePodSelection) {

          // remove pod if no registers selected
          // for(let podI in this.multiplePodSelection) {
          //   if(this.multiplePodSelection[podI].registersIDs.length == 0) {
          //     this.multiplePodSelection[podI].selected = false
          //   }
          // }
          // force the availableDirections and availableTimeframes to recompute because it doesnt detect changes made inside "multiplepodselection"
          this.multiplePodSelection = {...multiplePodSelection}
          if(this.viewMultiplePods)
            this.loadTimeSeries('onMPRegistersChange')
        },
        podIDOfRegister(registerID) {
          return this.allClipods.find(clipod => clipod.pod.variable.some(v => v.id == registerID)).pod.id
        },
        async loadDatesOfFirstAndLastData() {
          // gets the first and last dates where there is data for the selected POD(s)
          let podIDs = []
          if(this.viewMultiplePods) {
            for(const [podID, podSelection] of Object.entries(this.multiplePodSelection)) {
              if(podSelection.selected) {
                podIDs.push(podID)
              }
            }
          }
          else {
            podIDs = [this.clipod.pod.id]
          }
          let datesOfFirstAndLastData = await PODService.getDatesOfFirstAndLastData(podIDs)
          this.firstDataDate = datesOfFirstAndLastData.firstDataDate
          this.lastDataDate = datesOfFirstAndLastData.lastDataDate
          if(!this.compareByYear)
            this.checkThatDatesAreWithinBounds('load dates of first and last data')
        },
        checkThatDatesAreWithinBounds() {
          let startDateAsMoment = moment(this.startDate)
          let endDateAsMoment = moment(this.endDate)

          if(this.compareByYear) {
            const startOfYear = moment().startOf('year')
            const endOfYear = moment().endOf('year')
            // check that end date is after start date
            if(startDateAsMoment.isAfter(endDateAsMoment)) {
              this.endDate = endOfYear.toDate()
              this.startDate = startOfYear.toDate()
            }
            // check that dates are in the current year
            if(startDateAsMoment.isBefore(startOfYear)) {
              this.startDate = startOfYear.toDate()
            }
            if(endDateAsMoment.isAfter(endOfYear)) {
              this.endDate = endOfYear.toDate()
            }
          } else {
            const upperLimitDate = this.aggregation === 'YEAR'
              ? moment().endOf('year').toDate()
              : moment(this.lastDataDate).endOf('day').toDate();

            const lowerLimitDate = this.aggregation === 'YEAR'
              ? moment(this.firstDataDate).startOf('year').toDate()
              : moment(this.firstDataDate).startOf('day').toDate();

            if(moment(this.endDate).isAfter(moment(upperLimitDate))) {
              this.endDate = moment(upperLimitDate).toDate()
            }
            if(moment(this.startDate).isBefore(moment(lowerLimitDate))) {
              this.startDate = moment(lowerLimitDate).toDate()
            }
            // check that end date is after start date
            if(startDateAsMoment.isAfter(endDateAsMoment)) {
              this.endDate = moment(upperLimitDate).toDate()
              this.startDate = moment(lowerLimitDate).toDate()
            }
          }
        },
        /*getCurrentAggregationInMomentFormat() {
          switch(this.aggregation) {
            case 'QUARTHER_H':
            case 'HOUR':
              return 'days'
            case 'DAY':
              return 'days'
            case 'WEEK':
              return 'weeks'
            case 'MONTH':
              return 'months'
            case 'YEAR':
              return 'years'
          }
        },*/
        onBarClicked(datasetIndex, periodIndex) {
          this.startDate = moment(this.allDates[periodIndex]).toDate();
          let nextAggr = null;
          switch(this.aggregation) {
            case 'YEAR':
              nextAggr = 'MONTH';
              break;
            case 'MONTH':
              nextAggr = 'DAY';
              break;
            case 'WEEK':
              nextAggr = 'DAY';
              break;
            case 'DAY':
              // Verify pod includeIntervalReadings to allow 15' timeseries view
              if(!this.viewMultiplePods && this.clipod && this.clipod.pod && this.clipod.pod.includeIntervalReadings === true) {
                nextAggr = 'QUARTER_H';
              }
              break;
          }
          if (nextAggr) {
            this.changeAggregation(nextAggr);
          }
        },
        /*refreshSlider() {
          if (!this.firstDataDate || !this.lastDataDate) {
            return
          }
          if(!this.slider) {
            this.initializeUISlider()
            return
          }
          const minDateTimestamp = new Date(this.firstDataDate).getTime()
          const maxDateTimestamp = new Date(this.lastDataDate).getTime()
          const fromDateTimestamp = new Date(this.startDate).getTime()
          const toDateTimestamp = new Date(this.endDate).getTime()

          let step;
          const monthsDiff = moment(this.lastDataDate).diff(moment(this.firstDataDate), 'months')
          switch(this.aggregation) {
            case 'QUARTER_H':
              step = 1000 * 60 * 15
              break
            case 'HOUR':
              step = 1000 * 60 * 60
              break
            case 'DAY':
              step = 1000 * 60 * 60 * 24
              break
            case 'WEEK':
              step = 1000 * 60 * 60 * 24 * 7
              break
            case 'MONTH':
              step = (maxDateTimestamp - minDateTimestamp) / monthsDiff
              break
            case 'YEAR':
              step = 1000 * 60 * 60 * 24 * 365
              break
          }

          this.slider.noUiSlider.updateOptions({ step, range: { 'min': minDateTimestamp, 'max': maxDateTimestamp }})
          this.slider.noUiSlider.set([fromDateTimestamp, toDateTimestamp])
        // }*/
        /*initializeUISlider() {
          
          this.slider = this.$refs.slider
          if(!this.slider)
            return

          noUiSlider.create(this.slider, {
            start: [0, 0],
            connect: true,
            behaviour : 'drag',
            range: {
                'min': 0,
                'max': 100
            },
            tooltips: [
              { to: (value) => this.formatDateByAggregation('timestamp', value) },
              { to: (value) => this.formatDateByAggregation('timestamp', value) }
            ],
            pips: {
              mode: 'range',
              density: 100,
              format: {
                to: (value) => moment(value).format("DD-MM-YYYY"),
                from: (value) => moment(value).toDate().getTime()
              }
            },
            format: {
              from: (value) => parseInt(value),
              to: (value) => parseInt(value)
            }
          })

          this.slider.noUiSlider.on('end', () => {
            const values = this.slider.noUiSlider.get()
            if(this.selectedHighAggregation) {
              this.startDate = moment(values[0]).toDate()
              this.endDate = moment(values[1]).toDate()
            } else {
              this.startDate = moment(values[0]).startOf('day').toDate()
              this.endDate = moment(values[1]).startOf('day').toDate()
            }
            this.loadTimeSeries('initializeUISlider')
          })

          this.refreshSlider()
          
        },*/
        // formatDateByAggregation(type, value) {
        //   // From timestamp to date
        //   switch(this.aggregation) {
        //     case 'QUARTER_H':
        //       return type != 'timestamp' ? 'dd-MM-yyyy HH:mm' : moment(value).format("DD-MM-YYYY HH:mm")
        //     case 'HOUR':
        //       return type != 'timestamp' ? 'dd-MM-yyyy' : moment(value).format("DD-MM-YYYY HH:mm")
        //     case 'DAY':
        //       return type != 'timestamp' ? 'dd-MM-yyyy' : moment(value).format("DD-MM-YYYY")
        //     case 'WEEK':
        //       return type != 'timestamp' ? 'dd-MM-yyyy' : moment(value).format("ww-YYYY")
        //     case 'MONTH':
        //       return type != 'timestamp' ? 'MM-yyyy' : moment(value).format("MM-YYYY")
        //     case 'YEAR':
        //       return type != 'timestamp' ? 'yyyy' : moment(value).format("YYYY")
        //   }
        // },
        forceChartRefresh() {
          this.registersData = {...this.registersData}
        },
        manageRouteChange() {
          // this.historyStack = []
          this.showBenchmarking = this.isComparePage
          if(!this.isComparePage) {
            this.viewMultiplePods = false
            this.compareByYear = false
          } else if(['HOUR', 'QUARTER_H'].includes(this.aggregation)) {
            this.aggregation = 'DAY';
          }
          this.setAllTimeframes()
          this.setAllDirections()
          this.loadTimeSeries('manageRouteChange')
        },
        closeModal(isCancelled) {
          isCancelled ? this.loadingData = false : null;
          this.showModalIndex = false;
          this.showModalEvent = false;
        },
        async addIndex(source, maxDate) {
          this.loadingMessage = ''
          this.endDate = maxDate
          await this.loadDatesOfFirstAndLastData(source)
          this.loadTimeSeries('addIndex')
        },
        setAllTimeframes() {
          let timeframes = []
          if (this.viewMultiplePods) {
            this.allClipods.forEach(clipod => {
              timeframes = timeframes.concat(clipod.pod.variable.map(v => v.timeframe))
            })
            timeframes = timeframes
              .filter((value, index, self) => {
                return value && self.indexOf(value) == index
              })
          } else {
            timeframes = this.clipod.pod.variable.map(register => register.timeframe)
              .filter((value, index, self) => {
                return value && self.indexOf(value) == index
              })
          }
          this.allTimeframes = timeframes
          this.selectedTimeframes = this.allTimeframes
        },
        setSmartTfSelection() {
          if(this.availableTimeframes.includes("TH")) {
            return this.selectedTimeframes = ["TH"];
          }
          if(this.availableTimeframes.includes("HI") && this.availableTimeframes.includes("LO")) {
            return this.selectedTimeframes = ["HI","LO"];
          }
          if (this.availableTimeframes.length > 0) {
              return this.selectedTimeframes = [this.availableTimeframes[0]];
          }
          return this.selectedTimeframes = [];
        },
        setAllDirections() {
          this.selectedDirections = this.availableDirections
        },
        setDefaultDates() {
          this.startDate = moment().startOf('year').toDate();
          this.endDate = moment().endOf('year').toDate();

        },

    },
    created() {
      moment.tz.setDefault("Europe/Brussels");
      this.getLabel({ view: 'data' })
      Settings.defaultLocale = this.locale
      this.isComparePage = this.$route.path.includes("/comparison")
      this.showBenchmarking = this.isComparePage
      this.setDefaultDates()
    },
    /*mounted() {
      this.initializeUISlider()
    },*/
    watch: {
      $route() {
        this.isComparePage = this.$route.path.includes("/comparison")
        this.manageRouteChange()
      },
      viewMultiplePods() {
        if(!this.viewMultiplePods) {
          this.setSmartTfSelection()
          this.setAllDirections()
          this.loadDatesOfFirstAndLastData()
          this.showingDataInKWH = false
        }
      },
      compareByYear() {
        if(!this.compareByYear) {
          this.checkThatDatesAreWithinBounds('deactivated year comparison')
        }
      },
    }
}
</script>

<style lang="scss" scoped>
.graph-box {
  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }

  & > .graph-slider {
    margin-bottom: 3rem;
  }
}

.graph-top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

#slider {
  width: 90%;
  margin: 0 auto 20px auto;
}

.graph-bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  &-date {
    display: flex;
    justify-content: space-between;

    & > *:not(:last-child) {
      margin-right: 1.5rem;
    }
  }
}

@media screen and (max-width: 426px) {
  .graph-top > *:not(:last-child),
  .graph-bottom > *:not(:last-child) {
    margin-bottom: .5rem;
  }

  #slider {
    width: 80%;
  }
}

h1.subtitle {
  margin-bottom: .5rem;
}

.item-register {
  margin-left:20px;

  & > * {
    margin-top: .4rem;
  }
}
.tile-min-content {
  height: min-content;
}

.box-styled {
  padding: 1.25rem 0;
}

@media screen and (min-width: 769px) and (max-width: 1408px),
screen and (max-width: 476px) {
  .box-styled {
    padding: 1.25rem;
  }
}

@media screen and (min-width: 769px), screen and (max-width: 478px) {
  .full-width {
    width: 100%;

    &.button {
      display: flex;
      justify-content: space-between;
    }
  }
}

@media screen and (min-width: 769px) {
  .buttons.group-full-width {
    flex-wrap: nowrap;
    justify-content: space-evenly;
  }

  .button.group-full-width {
    flex-grow: 1;
  }
}

.buttons.has-addons .button:hover {
  z-index:5
}

.filters {
  display: flex;
  flex-direction: column;

  & > :last-child {
    margin-top: auto;
  }
}

.dropdown-menu {
  width: 100%;
}
</style>